import { useEffect, useState } from "react";
import CampaignService from "../services/CampaignService";

/**
 * Provides the known client company names (decrypted campaign_mapping.campaign_name)
 * used by PII detection to flag a client's company name typed into coaching-form fields.
 */
const useClientCompanyNames = () => {
  const [clientCompanyNames, setClientCompanyNames] = useState([]);

  useEffect(() => {
    let active = true;
    CampaignService.getKnownClientCompanyNames().then(names => {
      if (active) setClientCompanyNames(names);
    });
    return () => {
      active = false;
    };
  }, []);

  return clientCompanyNames;
};

export default useClientCompanyNames;
